module.exports = __webpack_public_path__ + "files/550b3955dde0dfb84a7bad6b121ed657.png";